var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplicateAva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C63D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6755_21020",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6755_21020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 25.8333H16.6667C16.2084 25.8333 15.8161 25.6702 15.49 25.3441C15.1634 25.0174 15 24.6249 15 24.1666V12.4999C15 12.0416 15.1634 11.6491 15.49 11.3224C15.8161 10.9963 16.2084 10.8333 16.6667 10.8333H22.5L27.5 15.8333V24.1666C27.5 24.6249 27.337 25.0174 27.0109 25.3441C26.6842 25.6702 26.2917 25.8333 25.8334 25.8333ZM21.6667 16.6666V12.4999H16.6667V24.1666H25.8334V16.6666H21.6667ZM13.3334 29.1666C12.875 29.1666 12.4828 29.0035 12.1567 28.6774C11.83 28.3508 11.6667 27.9583 11.6667 27.4999V15.8333H13.3334V27.4999H22.5V29.1666H13.3334Z",
    fill: "#F2F4F6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplicateAva);
export default __webpack_public_path__ + "static/media/ReplicateAva.1924fe11a1188dbb09c3e758efed4c89.svg";
export { ForwardRef as ReactComponent };